<template>
    <aside v-if="isOpen" >
        <aside id="modal" @click="closeModal" class="modal-box d-flex justify-content-center align-items-center">
            <slot name="outside"/>
            <article class="bg-gray-lightest mw-75 mw-sm-90">
                <header class="d-flex align-items-center p-4">
                    <slot name="header"/>
                    <close-button class="ml-auto" @click.native="$emit('close')"/>
                </header>

                <section class="p-4 px-md-9">
                    <slot/>
                </section>

                <footer class="d-flex justify-content-end align-items-center p-4">
                    <slot name="footer"/>
                </footer>
            </article>
        </aside>
    </aside>
</template>

<script>
    import { mixin as clickaway } from 'vue-clickaway';

    export default {
        mixins: [ clickaway ],
        
        props: {
            open: Boolean,
        },

        computed: {
            isOpen: function () {
                if ( this.open ) {
                    setTimeout( () => {
                        $( this.$el ).find( 'article' ).addClass( 'open' );
                    }, 200);
                } else {
                    $( this.$el ).find( 'article' ).removeClass( 'open' );
                }

                return this.open;
            },
        },

        methods: {
            closeModal: function(e = false) {
                if(e){
                    e.toElement === document.getElementById('modal') ? this.$emit('close') : ''
                }else{
                    this.$emit('close');
                }
            }
        }
    }
</script>

<style lang="scss">
    @import "./../../sass/variables";

    .modal-box {
        display: none;
        height: 100%;
        left: 0;
        position: fixed;
        top: 0;
        width: 100%;
        z-index: $zindex-modal-backdrop;

        article {
            max-height: 95vh;
            width: 42rem;
            overflow-y: auto;
            transform: scale3d( .5, .5, 1 );
            opacity: 0;
            transition: transform .5s ease-out, opacity .5s ease-out;

            &.open {
                transform: scale3d( 1, 1, 1 );
                opacity: 1;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/ModalBox.vue